import { Container } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import TrangDangKy from 'src/sections/dang-ky-the/dang-ky-the';

export default function Page() {
  return (
    <>
      <Helmet>
        <title> Đăng ký thẻ bạn đọc </title>
      </Helmet>

      <Container>
        <TrangDangKy />
      </Container>
    </>
  );
}
